import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import Footer from '../components/Footer';
import SubscriptionManagerTabView from '../components/SubscriptionManagerTabView';

const Pricing = () => {
    const { t, i18n } = useTranslation();
    const [openDropdown, setOpenDropdown] = useState(null);

    return (
        <>
            <Helmet>
                <title>{t('meta.home.title')}</title>
                <meta name="description" content={t('meta.home.description')} />
            </Helmet>
            <div className="min-h-screen bg-gradient-to-br from-cyan-300 via-white to-pink-400 flex flex-col">
                <main className="flex-1">
                    <div className="flex justify-between items-center px-4 py-4 lg:px-10 relative">
                        <div className='flex justify-center items-center'>
                            <img src="/logo2.png" className="w-12 h-12" alt="Weddinfy" />
                            <h1 className="text-xl font-semibold text-gray-800">{t('appName')}</h1>
                        </div>
                        <div className="flex items-center space-x-4">
                            {/* Language Dropdown */}
                            <div className="relative" tabIndex={0} onBlur={() => setOpenDropdown(null)}>
                                <div className="bg-white border border-gray-500 rounded-xl px-2 cursor-pointer flex items-center" onClick={() => setOpenDropdown(prev => prev === "language" ? null : "language")} >
                                    <span className="text-gray-800 uppercase">
                                        {i18n.language === 'hr' && '🇭🇷'}
                                        {i18n.language === 'en' && '🇬🇧'}
                                        {i18n.language === 'de' && '🇩🇪'}
                                    </span>
                                    {openDropdown === "language" ? (
                                        <FaChevronUp className="ml-2 text-gray-600" />
                                    ) : (
                                        <FaChevronDown className="ml-2 text-gray-600" />
                                    )}
                                </div>

                                {openDropdown === "language" && (
                                    <div className="absolute right-0 mt-1 z-50 w-full min-w-[130px] bg-white border border-gray-500 rounded-xl shadow-lg">
                                        {[
                                            { code: 'hr', label: 'Hrvatski', flag: '🇭🇷' },
                                            { code: 'en', label: 'English', flag: '🇬🇧' },
                                            { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
                                        ].map((lang) => (
                                            <button key={lang.code} type="button"
                                                onMouseDown={() => {
                                                    i18n.changeLanguage(lang.code);
                                                    localStorage.setItem('lang', lang.code);
                                                    setOpenDropdown(null);
                                                }}
                                                className="w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 rounded-xl flex items-center gap-2" >
                                                <span className="text-xl">{lang.flag}</span>
                                                <span>{lang.label}</span>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                            {/* Login link */}
                            <Link to="/login" className="text-gray-800 hover:underline">
                                {t('login')}
                            </Link>
                        </div>
                    </div>

                    {/* Hero Section */}
                    <section className="py-10 md:py-20">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <h1 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-4">{t('pricing.title')}</h1>
                            <SubscriptionManagerTabView />
                        </div>
                    </section>


                </main>
                <footer>
                    <Footer />
                </footer>
            </div>
        </>
    );
};

export default Pricing;
